import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SenderIdService {
  #getCurrentUserUUID!: string;

  public get getCurrentUserUUID(): string {
    if (!this.#getCurrentUserUUID) {
      this.#getCurrentUserUUID = this.generateSenderId();
    }

    return this.#getCurrentUserUUID;
  }

  public set setCurrentUserUUID(token: string) {
    this.#getCurrentUserUUID = token;
  }

  public generateSenderId(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
}
